export const defaultState = () => ({
	taxonomies: {},
	config: {
		hasMailPoet: false,
		isWooActive: null,
		isWooConnected: null,
		isEddActive: null,
		isEddConnected: null,
		eddVersion: {},
		mailPoetLists: [],
		mailPoetFields: [],
	},
	posts: [],
	postTypes: [],
	campaigns: [],
	search: '',
	wooKey: {
		id: '',
		description: '',
		truncated: '',
		editUrl: '',
	},
	eddKey: '',
	eddToken: '',
	error: false,
});
const state = defaultState();

export default state;
